export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECT_BY_ID = "GET_PROJECT_BY_ID";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const CREATE_PROJECT = "CREATE_PROJECT";
